import { render, staticRenderFns } from "./PopupLayout.vue?vue&type=template&id=4ea4cfcc&scoped=true"
import script from "./PopupLayout.vue?vue&type=script&lang=ts"
export * from "./PopupLayout.vue?vue&type=script&lang=ts"
import style0 from "./PopupLayout.vue?vue&type=style&index=0&id=4ea4cfcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea4cfcc",
  null
  
)

export default component.exports